import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ForumCllajService {

  verifyInscriptionEndpoint = "cllaj/inscriptions/verify";
  atelierEndpoint = "cllaj/ateliers/add";
//   verifyInscriptionEndpoint = "scripts/site-evenement/add-user.php";

  constructor(private http: HttpClient, private router:Router) {

  }

  // post verify inscription endpoint
  verifyInscription(email) {
    // return if email exist and has "depot de demande"
    return this.http.post<any>( environment.apiUrl + '/' + this.verifyInscriptionEndpoint, { email: email });
  }

  // post atelier endpoint
  addAtelier(atelierData) {
    return this.http.post<any>( environment.apiUrl + '/' + this.atelierEndpoint, atelierData);
  }



  convertParameters(obj) {
    let str = '';
    for (let key in obj) {
      if (str != '') {
        str += '&';
      }
      str += key + '=' + encodeURIComponent(obj[key]);
    }
    return str;
  }

}
